<app-nav
    [titulo]="servicio ? 'Editar servicio: ' + servicio.nombre : 'Nuevo servicio contratado'"
    [descripcion]="servicio ? 'Aquí podrá modificar los datos del servicio contratado.' : 'Complete los datos del nuevo servicio contratado (ej: IKE, ABSA).'">
    <div class="edit-servicio-contratado basic-avm-editor">
        <div class="form-stepper">
            <form [formGroup]="form" class="form-step">

                <h3 class="form-step-title">{{ servicio ? 'Editar servicio contratado' : 'Nuevo servicio contratado' }}</h3>
                <span class="form-step-description">
                    {{ servicio ? 'Modificá los datos y guardá los cambios.' : 'Completá los datos del nuevo servicio.' }}
                </span>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input matInput formControlName="nombre" placeholder="Ej: IKE, ABSA">
                        <mat-error *ngIf="form.controls['nombre'].hasError('required')">El nombre es requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Código técnico</mat-label>
                        <input matInput formControlName="codigo" placeholder="Ej: IKE, ABSA" style="text-transform: uppercase;">
                        <mat-hint>Clave usada por el motor de cotización</mat-hint>
                        <mat-error *ngIf="form.controls['codigo'].hasError('required')">El código es requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-radio-line">
                    <span class="radio-line-label">Base de cálculo</span>
                    <div class="radios">
                        <mat-radio-group formControlName="base">
                            <mat-radio-button value="ALQUILER">Alquiler</mat-radio-button>
                            <mat-radio-button value="EXPENSAS">Expensas</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Variable (%)</mat-label>
                        <input matInput formControlName="variable" type="number" style="text-align: right;">
                        <span matSuffix>&nbsp;%</span>
                        <mat-error *ngIf="form.controls['variable'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Pricing fijo</mat-label>
                        <input matInput formControlName="pricingFijo" type="number" style="text-align: right;">
                        <mat-error *ngIf="form.controls['pricingFijo'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Mínimo por mes (ARS)</mat-label>
                        <input matInput formControlName="minPorMes" type="number" style="text-align: right;">
                        <mat-error *ngIf="form.controls['minPorMes'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Máximo por mes (ARS)</mat-label>
                        <input matInput formControlName="maxPorMes" type="number" style="text-align: right;">
                        <mat-error *ngIf="form.controls['maxPorMes'].hasError('required')">Requerido</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-radio-line">
                    <span class="radio-line-label">Tipo de producto</span>
                    <div class="radios">
                        <mat-radio-group formControlName="tipoProducto">
                            <mat-radio-button value="VIVIENDA">Vivienda</mat-radio-button>
                            <mat-radio-button value="COMERCIAL">Comercial</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Zona (dejar vacío para Default)</mat-label>
                    <mat-select formControlName="idZona">
                        <mat-option [value]="null">Default (todas las zonas)</mat-option>
                        <mat-option *ngFor="let zona of zonas" [value]="zona.id">
                            {{ zona.nombre }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Los servicios Default aplican a todas las zonas sin override específico.</mat-hint>
                </mat-form-field>

                <div class="form-radio-line">
                    <span class="radio-line-label">Estado</span>
                    <div class="radios">
                        <mat-radio-group formControlName="activo">
                            <mat-radio-button [value]="true">Activo</mat-radio-button>
                            <mat-radio-button [value]="false">Inactivo</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ servicio ? 'Guardar cambios' : 'Crear servicio' }}
                    </button>
                </div>

            </form>
        </div>
    </div>
</app-nav>
